var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhonePurple = function SvgPhonePurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#phone-purple_svg__a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "M3.195 8.667c-.9-1.526-1.496-3.302-1.739-5.28-.037-.301-.055-.453-.032-.646.074-.61.608-1.213 1.204-1.36.19-.048.381-.048.764-.048v0c.341 0 .511 0 .661.03a1.6 1.6 0 0 1 1.149.896c.064.138.105.304.188.634l.043.173c.167.665.25.998.263 1.323a3.2 3.2 0 0 1-.383 1.66c-.155.286-.376.548-.818 1.073zm0 0a11.63 11.63 0 0 0 3.91 4m0 0c1.576.978 3.431 1.622 5.507 1.877.303.037.454.056.647.032.61-.074 1.213-.608 1.36-1.204.048-.19.048-.387.048-.784v0c0-.328 0-.491-.03-.641a1.6 1.6 0 0 0-.896-1.148c-.138-.065-.303-.106-.634-.189l-.244-.06c-.705-.177-1.058-.265-1.406-.275a3.2 3.2 0 0 0-1.413.285c-.317.144-.608.361-1.19.797z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "phone-purple_svg__a",
    x1: 1.333,
    x2: 14.667,
    y1: 8.258,
    y2: 8.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#580EB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6701A9"
  })))));
};
export default SvgPhonePurple;